import { render, staticRenderFns } from "./M_Product.vue?vue&type=template&id=724da4d9&"
import script from "./M_Product.vue?vue&type=script&lang=js&"
export * from "./M_Product.vue?vue&type=script&lang=js&"
import style0 from "./M_Product.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports